module.exports = __webpack_public_path__ + "img/63.ad5e97f0.png";